import React, { Component } from "react";
import { Hub } from "aws-amplify";
import Header from "../../components/Header/index";
import { Container, Col } from "react-bootstrap";
import AWS_CONSTANTS from "../../constants/aws";
import OrderSelectionModal from "../../components/OrderSelectionModal/index";
import HomeForm from "../../components/HomeForm/index";
import strings from "../../constants/strings";
import Footer from "../../components/Footer/index";
import FinalCart from "../../components/FinalCart/index";
import LoginModal from "../../components/LoginModal/index";
import SignupModal from "../../components/SignupModal/index";
import Loader from "../Loader/index";
import HomeSearch from "../../components/HomeSearch/index";
import CustomAlert from "../../components/CustomAlert/index";
import PlaceOrder from "../../components/PlaceOrder/index";
import {
  getCategories,
  getProducts,
  productWithPackagingExistsInCart,
  getCurrentAuthenticatedUser,
  productIdExistsInCart,
  signOut,
  getCartAmount,
  updateCartCache,
  getCartCache,
  updateUserAddress,
  getCurrentUserAddress,
  userHasAddress,
  isMyScriptLoaded,
  getDeliveryState,
  verifyCurrentUserAttributePool,
} from "../../helper";
import { getCategoriesView } from "../../components/helper";
import ImageGallery from "../ImageGallery";
import GOOGLE_KEY from "../../config/maps";
import "./styles.scss";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      showProductCatalog: false,
      products: {},
      selectedCategory: {},
      selectedSubCategory: null,
      cart: getCartCache(),
      showLogin: false,
      showSignup: false,
      given_name: null,
      username: null,
      email: null,
      loggedIn: false,
      shippingCharges: null,
      isStorePickup: null,
      resendSignupVerification: false,
      loading: true,
      showAlert: false,
      alertHeader: "",
      alertContent: "",
      alertVariant: null,
      readyToOrder: false,
      askUsername: true,
      codApplied: null,
      confirmAddress: null,
      closeModal: null,
      showPriceValue: null,
      shippingChargesConfirmed: false,
      selectedStorePickupSlot: null,
      selectedStorePickupDate: null,
      addresses: [],
      deliveryState: null,
      completeSocialSignup: false,
      verifyPhoneNumber: false,
    };
  }

  handleChangeSavedAddress = (event, index) => {
    const { name, value } = event.target;
    const { addresses } = this.state;
    let address = Object.assign({}, addresses[index]);
    address[name] = value;
    addresses[index] = address;
    this.setState({ addresses });
  };

  hubListener = ({ payload: { event, data } }) => {
    switch (event) {
      case "signIn":
        getCurrentAuthenticatedUser(true)
          .then((user) => user)
          .then((user) => user && this.getLoggedInDetails(user))
          .catch((error) => alert(error));
        break;
      default:
        break;
    }
  };

  async componentDidMount() {
    const { loggedIn, showLogin, showSignup } = this.state;
    !loggedIn &&
      !showSignup &&
      !showLogin &&
      (await getCurrentAuthenticatedUser()
        .then((user) => user)
        .then((user) => user && this.getLoggedInDetails(user))
        .catch(() => this.handleLogout()));
    !loggedIn && Hub.listen("auth", this.hubListener);

    const googleMapsSrc = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_KEY.KEY}&libraries=places`;
    if (!isMyScriptLoaded(googleMapsSrc)) {
      const mapScript = document.createElement("script");
      mapScript.src = googleMapsSrc;
      mapScript.async = false;
      document.body.appendChild(mapScript);
    }
    const { categories, showPriceValue, deliveryState } = this.state;
    if (deliveryState === null) {
      getDeliveryState().then((result) =>
        this.setState({ deliveryState: result, isStorePickup: !result })
      );
    }
    if (categories.length === 0 || showPriceValue === null) {
      getCategories().then((result) =>
        this.setState({
          categories: result.categories,
          showPriceValue: result.showPriceValue,
          loading: false,
        })
      );
    }
    window.addEventListener("popstate", this.closeModalOnBack);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.closeModalOnBack);
    Hub.remove("auth", this.hubListener);
  }

  handleUpdateUserAddresses = async (update, address, index) => {
    const addresses = await getCurrentUserAddress();
    let newAddresses = Object.assign([], addresses);
    switch (update) {
      case 0:
        const i = userHasAddress(address, addresses);
        if (i !== null) {
          newAddresses.splice(i, 1);
        }
        break;
      case 1:
        newAddresses.push(address);
        break;

      case 2:
        newAddresses[index] = address;
        break;
      default:
        return;
    }
    this.setState({ addresses: newAddresses });
    return await updateUserAddress(JSON.stringify(newAddresses)).then(
      (result) => {
        this.setState({ addresses: newAddresses });
        return result;
      }
    );
  };

  handleFormChange = (event) =>
    this.setState({ [event.target.name]: event.target.value });

  closeModalOnBack = () => this.state.closeModal();

  handleLogout = async () =>
    await signOut()
      .then(() =>
        this.setState({
          username: null,
          phone_number: null,
          email: null,
          given_name: null,
          loggedIn: false,
          addresses: [],
        })
      )
      .then(() =>
        this.handleShowAlert("Logout", "Logged out successfully", true)
      );

  addToCart = (product, quantity = null, packaging = null) => {
    const newProduct = Object.assign({}, product);
    const keysToRemove = [
      "product_desc",
      "sku",
      "sub_category",
      "brand",
      "popular_choice",
      "luxury_grade",
      "dietician_choice",
      "image_src",
      "listing_status",
    ];
    for (var i = 0; i < keysToRemove.length; i++) {
      newProduct &&
        Object.keys(newProduct).includes(keysToRemove[i]) &&
        delete newProduct[keysToRemove[i]];
    }
    let { cart } = this.state;
    if (quantity == null) {
      packaging && (newProduct.packaging = packaging);
      newProduct.quantity = 1;
      cart.push(newProduct);
    } else if (quantity >= 0) {
      const productUpdateIndex = packaging
        ? productWithPackagingExistsInCart(
            newProduct.product_id,
            packaging,
            cart
          )
        : productIdExistsInCart(newProduct.product_id, cart);
      if (productUpdateIndex != null) {
        quantity <= 0
          ? cart.splice(productUpdateIndex, 1)
          : (cart[productUpdateIndex].quantity = quantity);
      } else {
        newProduct.quantity = quantity;
        packaging && (newProduct.packaging = packaging);
        cart.push(newProduct);
      }
    }
    updateCartCache(cart, true);
    this.setState({ cart });
  };

  deleteProductFromCart = (productId) => {
    let { cart } = this.state;
    const deleteIndex = cart.findIndex(
      (element) => element.product_id === productId
    );
    cart.splice(deleteIndex, 1);
    updateCartCache(cart, true);
    this.setState({ cart });
  };

  handleCategoriesOnClick = async (i) => {
    const { categories } = this.state;
    this.setState({ loading: true, searchString: null });
    await getProducts({
      categoryId: categories[i]["category_id"],
      groupBy: "sub_category",
    })
      .then((result) =>
        this.setState({
          products: result,
          selectedSubCategory: result["sub_categories"][0],
          selectedCategory: categories[i],
        })
      )
      .then(() => this.props.history.push({ hash: "catalog" }))
      .then(() =>
        this.setState({
          showProductCatalog: true,
          loading: false,
          closeModal: () => {
            this.setState({ showProductCatalog: false });
            this.props.history.push({ hash: "" });
          },
        })
      );
  };

  getCategoriesColumns = (categories, startIndex, endIndex, handleOnClick) => {
    let retval = [];
    for (let i = startIndex; i <= endIndex; i++) {
      retval.push(
        <Col
          className={`category-item pl-2 pr-2`}
          key={categories[i]["category_id"]}
        >
          <div
            className="h-100 w-100 d-flex category"
            style={{
              backgroundImage: `url('${AWS_CONSTANTS.ASSETS_URL}${categories[i]["image_src"]}')`,
            }}
            onClick={() => handleOnClick(i)}
          >
            <p className="position-absolute text-center category-name">
              {categories[i]["category_name"]}
            </p>
            {!this.props.isMobile && (
              <p className="position-absolute text-center category-description">
                {categories[i]["category_description"]}
              </p>
            )}
            <div className="overlay h-100 w-100 d-block" />
          </div>
        </Col>
      );
    }
    return retval;
  };

  getOAuthUserFromResponse = async (user) => {
    try {
      const result = user.attributes;
      if (
        !result.phone_number ||
        !result.email ||
        !result.given_name ||
        !result.phone_number_verified
      ) {
        if (!result.phone_number && user.attributes.phone_number) {
          this.setState({
            username: user.attributes.phone_number.substring(
              3,
              user.attributes.phone_number.length
            ),
          });
        } else if (result.phone_number) {
          this.setState({
            username: result.phone_number.substring(
              3,
              result.phone_number.length
            ),
          });
        }
        if (
          !result.given_name &&
          (user.attributes.name || user.attributes.given_name)
        ) {
          if (user.attributes.name) {
            this.setState({ given_name: user.attributes.name });
          } else if (user.attributes.given_name) {
            this.setState({ given_name: user.attributes.given_name });
          }
        } else if (result.given_name || result.name) {
          if (result.name) {
            this.setState({ given_name: result.name });
          } else if (result.given_name) {
            this.setState({ given_name: result.given_name });
          }
        }
        if (!result.email && user.attributes.email) {
          this.setState({ email: user.attributes.email });
        } else if (result.email) {
          this.setState({ email: result.email });
        }
        result.phone_number &&
          !result.phone_number_verified &&
          (await verifyCurrentUserAttributePool("phone_number").then(() =>
            this.setState({
              verifyPhoneNumber: true,
            })
          ));
        this.setState({ showSignup: true, completeSocialSignup: true });
        return false;
      }
      return { attributes: result };
    } catch (error) {
      this.handleShowAlert("Complete Signup", error.message);
    }
  };

  getLoggedInDetails = async (user) => {
    const { loggedIn } = this.state;
    if (!loggedIn) {
      user.attributes.identities &&
        (user = await this.getOAuthUserFromResponse(user));

      if (user && user.attributes) {
        let { phone_number, email, address, given_name, name } =
          user.attributes;
        this.setState({
          username: phone_number.substring(3, phone_number.length),
          given_name: name || given_name,
          email,
          addresses: JSON.parse(address),
          loggedIn: true,
        });
      }
    }
  };

  handleShowAlert = (alertHeader, alertContent, success = false) => {
    success && this.setState({ alertVariant: "success" });
    this.setState({
      alertContent,
      alertHeader,
      showAlert: true,
    });
    setTimeout(() => {
      this.handleCloseAlert();
    }, 4000);
  };

  handleCloseAlert = () =>
    this.setState({
      showAlert: false,
      alertHeader: "",
      alertContent: "",
      alertVariant: "danger",
    });

  render() {
    const {
      selectedCategory,
      products,
      showProductCatalog,
      cart,
      showLogin,
      showSignup,
      username,
      given_name,
      email,
      loggedIn,
      shippingCharges,
      isStorePickup,
      loading,
      resendSignupVerification,
      showAlert,
      alertContent,
      alertHeader,
      alertVariant,
      readyToOrder,
      askUsername,
      codApplied,
      confirmAddress,
      closeModal,
      showPriceValue,
      categories,
      shippingChargesConfirmed,
      addresses,
      selectedStorePickupSlot,
      selectedStorePickupDate,
      deliveryState,
      completeSocialSignup,
      verifyPhoneNumber,
    } = this.state;
    const { isMobile } = this.props;
    const { cartAmount } = getCartAmount(cart);

    return loading ? (
      <Loader />
    ) : (
      <div className="background-image">
        <Header
          loggedIn={loggedIn}
          showLogin={() => this.setState({ showLogin: true })}
          handleLogout={this.handleLogout}
          categories={categories}
          imageGallery={this.props.imageGallery}
        />
        <div className="home position-relative">
          <CustomAlert
            showAlert={showAlert}
            handleCloseAlert={this.handleCloseAlert}
            header={alertHeader}
            content={alertContent}
            variant={alertVariant || "danger"}
          />

          {this.props.imageGallery ? (
            <ImageGallery categories={categories} isMobile={isMobile} />
          ) : (
            <>
              <div className="heading text-center" id="order-section">
                <h2 className="text-capitalize">{strings.ORDER_SELECTION}</h2>
              </div>
              <div className="home-search-container">
                <HomeSearch
                  cart={cart}
                  addToCart={this.addToCart}
                  isMobile={isMobile}
                />
              </div>
              <Container>
                {getCategoriesView(
                  categories,
                  this.getCategoriesColumns,
                  this.handleCategoriesOnClick,
                  { xs: 2, sm: 2, md: 4, lg: 4 }
                )}
              </Container>
              {cart.length > 0 && (
                <>
                  <FinalCart
                    cart={cart}
                    deleteProductFromCart={this.deleteProductFromCart}
                    cartAmount={cartAmount}
                    addToCart={this.addToCart}
                    isMobile={isMobile}
                    showAlert={this.handleShowAlert}
                    loggedIn={loggedIn}
                    showLogin={() => this.setState({ showLogin: true })}
                  />

                  {loggedIn && (
                    <HomeForm
                      loggedIn={loggedIn}
                      email={email}
                      addresses={addresses}
                      given_name={given_name}
                      username={username}
                      handleChangeSavedAddress={this.handleChangeSavedAddress}
                      showPriceValue={showPriceValue}
                      handleFormChange={this.handleFormChange}
                      codApplied={codApplied}
                      deliveryState={deliveryState}
                      handleUpdateUserAddresses={this.handleUpdateUserAddresses}
                      selectedStorePickupSlot={selectedStorePickupSlot}
                      selectedStorePickupDate={selectedStorePickupDate}
                      showLogin={() => this.setState({ showLogin: true })}
                      setSelectedStorePickupDate={(value) =>
                        this.setState({ selectedStorePickupDate: value })
                      }
                      setSelectedStorePickupSlot={(value) =>
                        this.setState({ selectedStorePickupSlot: value })
                      }
                      setCodApplied={(value) =>
                        this.setState({ codApplied: value })
                      }
                      shippingCharges={shippingCharges}
                      setShippingCharges={(value) =>
                        this.setState({ shippingCharges: value })
                      }
                      isStorePickup={isStorePickup}
                      setIsStorePickup={(value) =>
                        this.setState({ isStorePickup: value })
                      }
                      placeOrder={(address) =>
                        this.setState({
                          readyToOrder: true,
                          confirmAddress: address,
                        })
                      }
                      showAlert={this.handleShowAlert}
                      isMobile={isMobile}
                      cartAmount={cartAmount}
                      cart={cart}
                    />
                  )}
                </>
              )}
              <OrderSelectionModal
                products={products}
                selectedCategory={selectedCategory}
                open={showProductCatalog}
                addToCart={this.addToCart}
                cart={cart}
                isMobile={isMobile}
                closeModal={closeModal}
                showPriceValue={showPriceValue}
                showAlert={this.handleShowAlert}
              />

              <SignupModal
                showSignup={showSignup}
                closeSignupModal={() => this.setState({ showSignup: false })}
                getLoggedInDetails={this.getLoggedInDetails}
                resendSignupVerification={resendSignupVerification}
                showAlert={this.handleShowAlert}
                cancelPlaceOrder={() => this.setState({ readyToOrder: false })}
                user={{ email, given_name, username }}
                address={confirmAddress}
                openLoginModal={() => this.setState({ showLogin: true })}
                isStorePickup={isStorePickup}
                handleFormInputChange={this.handleFormChange}
                completeSocialSignup={completeSocialSignup}
                setCompleteSocialSignup={(value) =>
                  this.setState({ completeSocialSignup: value })
                }
                verifyPhoneNumber={verifyPhoneNumber}
                setVerifyPhoneNumber={(value) =>
                  this.setState({ verifyPhoneNumber: value })
                }
                handleLogout={this.handleLogout}
                isMobile={isMobile}
              />
              {readyToOrder && (
                <PlaceOrder
                  show={readyToOrder}
                  closeModal={() => this.setState({ readyToOrder: false })}
                  loggedIn={loggedIn}
                  cartAmount={cartAmount}
                  cart={cart}
                  shippingCharges={shippingCharges}
                  isStorePickup={isStorePickup}
                  selectedStorePickupSlot={selectedStorePickupSlot}
                  selectedStorePickupDate={selectedStorePickupDate}
                  user_attributes={{ given_name, email, username }}
                  codApplied={codApplied}
                  confirmAddress={confirmAddress}
                  showAlert={this.handleShowAlert}
                  addresses={addresses}
                  isMobile={isMobile}
                  shippingChargesConfirmed={shippingChargesConfirmed}
                  showLoader={(value) => this.setState({ loading: value })}
                  cancelPlaceOrder={() =>
                    this.setState({ readyToOrder: false, confirmAddress: null })
                  }
                  setShippingCharges={(value) =>
                    this.setState({ shippingCharges: value })
                  }
                  setShippingChargesConfirmed={(value) =>
                    this.setState({ shippingChargesConfirmed: value })
                  }
                />
              )}
              <Footer
                isMobile={isMobile}
                setCloseModal={(value) => this.setState({ closeModal: value })}
                closeModal={closeModal}
              />
            </>
          )}
          <LoginModal
            showLogin={showLogin}
            username={username}
            isMobile={isMobile}
            askUsername={askUsername}
            getLoggedInDetails={this.getLoggedInDetails}
            closeLoginModal={() => this.setState({ showLogin: false })}
            handleFormInputChange={this.handleFormChange}
            showSignUpModal={(resendVerification = false) =>
              this.setState({
                showSignup: true,
                resendSignupVerification: resendVerification,
              })
            }
            showAlert={this.handleShowAlert}
            cancelPlaceOrder={() => this.setState({ readyToOrder: false })}
          />
        </div>
      </div>
    );
  }
}

export default Home;
